import { useState } from 'react'
import type { Filter, SearchRequest } from '@medplum/core'
import type { DatesRangeValue } from '@mantine/dates'
import dayjs from 'dayjs'

export function useDateRangeFilter(
  search: Pick<SearchRequest, 'filters'>,
  setFilters: (filters: Filter[]) => void,
  removeFilter: (code: string) => void,
) {
  const [dateRange, setDateRange] = useState<DatesRangeValue<string>>()

  const onDateRange = (dr: DatesRangeValue<string>) => {
    const [from, to] = dr
    setDateRange(dr)
    if (from) {
      const effectiveTo = to ?? from
      const fromDate = dayjs(`${from.substring(0, 10)}T00:00:00`)
        .startOf('day')
        .toISOString()
      const toDate = dayjs(`${effectiveTo.substring(0, 10)}T00:00:00`)
        .endOf('day')
        .toISOString()
      const current = (search.filters ?? []).filter((f) => f.code !== 'date')
      setFilters([
        ...current,
        { code: 'date', operator: 'ge', value: fromDate },
        { code: 'date', operator: 'le', value: toDate },
      ])
    } else {
      removeFilter('date')
    }
  }

  return { dateRange, onDateRange }
}
